import styled from "styled-components";

import RuneKnightImg from "./img/3rd/icon_jobs_4060.gif"
import ArcBishopImg from "./img/3rd/icon_jobs_4063.gif"
import WarlockImg from "./img/3rd/icon_jobs_4061.gif"
import MecanicImg from "./img/3rd/icon_jobs_4064.gif"
import RangerImg  from "./img/3rd/icon_jobs_4062.gif"
import GuilhotineImg  from "./img/3rd/icon_jobs_4065.gif"

import RoyalGuardImg from "./img/3rd/icon_jobs_4073.gif"
import SuraImg from "./img/3rd/icon_jobs_4077.gif"
import SorcererImg from "./img/3rd/icon_jobs_4074.gif"
import ShadowChaserImg from "./img/3rd/icon_jobs_4079.gif"
import BiochemistImg from "./img/3rd/icon_jobs_4078.gif"
import MinstrelImg  from "./img/3rd/icon_jobs_4075.gif"
import MuseImg  from "./img/3rd/icon_jobs_4076.gif"

function ThirdClassQuests() {
    return(<>
        <ClassListContainer>
            <TitleContainer>Classes 3 - 1</TitleContainer>
            <ClassListItem>
                <ClassListIcon iconImage={RuneKnightImg}/>
                <ClassListDescription>Cavaleiro Rúnico </ClassListDescription>
            </ClassListItem>
            <ClassListItem>
                <ClassListIcon iconImage={ArcBishopImg}/>
                <ClassListDescription>Arcebispo </ClassListDescription>
            </ClassListItem>
            <ClassListItem>
                <ClassListIcon iconImage={WarlockImg}/>
                <ClassListDescription>Arcano </ClassListDescription>
            </ClassListItem>
            <ClassListItem>
                <ClassListIcon iconImage={MecanicImg}/>
                <ClassListDescription>Mecânico </ClassListDescription>
            </ClassListItem>
            <ClassListItem>
                <ClassListIcon iconImage={RangerImg}/>
                <ClassListDescription>Ranger </ClassListDescription>
            </ClassListItem>
            <ClassListItem>
                <ClassListIcon iconImage={GuilhotineImg}/>
                <ClassListDescription>Sicário</ClassListDescription>
            </ClassListItem>
        </ClassListContainer>

        <ClassListContainer>
            <TitleContainer>Classes 3 - 2</TitleContainer>
            <ClassListItem>
                <ClassListIcon iconImage={RoyalGuardImg}/>
                <ClassListDescription>Guarda Real </ClassListDescription>
            </ClassListItem>
            <ClassListItem>
                <ClassListIcon iconImage={SuraImg}/>
                <ClassListDescription>Shura</ClassListDescription>
            </ClassListItem>
            <ClassListItem>
                <ClassListIcon iconImage={SorcererImg}/>
                <ClassListDescription>Feiticeiro </ClassListDescription>
            </ClassListItem>
            <ClassListItem>
                <ClassListIcon iconImage={ShadowChaserImg}/>
                <ClassListDescription>Renegado </ClassListDescription>
            </ClassListItem>
            <ClassListItem>
                <ClassListIcon iconImage={BiochemistImg}/>
                <ClassListDescription>Bioquímico </ClassListDescription>
            </ClassListItem>
            <ClassListItem>
                <ClassListIcon iconImage={MinstrelImg}/>
                <ClassListDescription>Trovador </ClassListDescription>
            </ClassListItem>
            <ClassListItem>
                <ClassListIcon iconImage={MuseImg}/>
                <ClassListDescription>Musa </ClassListDescription>
            </ClassListItem>
        </ClassListContainer>

    </>
    )
}

const TitleContainer = styled.h1`

`

const ClassListContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 300px;
    margin: 30px 0;
`

const ClassListItem = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-evenly;
    width: 250px;
    padding: 8px;
    margin: 2px 0;
    transition: .2s ease-in-out;

    cursor: url('cursors0007.png'), pointer;

    &:active {
        cursor: url('cursors0008.png'), pointer; 
     }

     &:hover {
        background-color: rgba(102, 38, 175, 1);
        color: white;
        scale: 1.2;
    }
`

const ClassListIcon = styled.div`
    background-image: url(${props => props.iconImage});
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center center;
    width: 25px;
    height: 25px;
    //border: solid 1px rgba(0,0,0,1)
`

const ClassListDescription = styled.span`
    width: 200px;
    height: 25px;
`



export default ThirdClassQuests;